var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWastage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.7 20.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#212121;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.85,0C4.59,0,0,1.09,0,3.49a.49.49,0,0,0,0,.12L.06,4l2.1,13.6a.79.79,0,0,0,0,.13c.67,2,3.16,3.23,6.66,3.23s6-1.21,6.66-3.23a.79.79,0,0,0,0-.13L17.64,4l.05-.35a.49.49,0,0,0,0-.12C17.7,1.09,13.11,0,8.85,0ZM14,17.24c-.47,1.28-2.43,2.08-5.12,2.08s-4.65-.8-5.12-2.08L2,5.79A17.76,17.76,0,0,0,8.85,7a17.76,17.76,0,0,0,6.89-1.18ZM16.08,3.57v0c-.3.59-2.8,1.77-7.22,1.77S1.93,4.19,1.63,3.6v0a.31.31,0,0,1,0-.08s0,0,0,0c0-.56,2.58-1.87,7.24-1.87S16,2.91,16.09,3.47c0,0,0,0,0,0A.31.31,0,0,1,16.08,3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.62,3.57a.31.31,0,0,1,0-.08s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.1,3.49a.31.31,0,0,1,0,.08v-.1S16.1,3.48,16.1,3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,16.63h-.08a.78.78,0,0,1-.71-.87l.53-5.37a.8.8,0,1,1,1.6.16l-.54,5.37A.8.8,0,0,1,11,16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.7,16.63a.8.8,0,0,1-.79-.72l-.54-5.37a.81.81,0,0,1,.72-.88.8.8,0,0,1,.87.72l.54,5.37a.8.8,0,0,1-.72.87Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWastage);
export default __webpack_public_path__ + "static/media/Wastage.29b42110ab915fc4cfe0f0770c15c863.svg";
export { ForwardRef as ReactComponent };